import { render, staticRenderFns } from "./ComingSoonModal.vue?vue&type=template&id=3c24a6e9&scoped=true"
import script from "./ComingSoonModal.vue?vue&type=script&lang=js"
export * from "./ComingSoonModal.vue?vue&type=script&lang=js"
import style0 from "./ComingSoonModal.vue?vue&type=style&index=0&id=3c24a6e9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c24a6e9",
  null
  
)

export default component.exports